import { Box, CircularProgress, Typography } from "@mui/material";

export default function AuthLoadingScreen() {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0b0b0b", // match your dark login theme
        gap: 2,
      }}
    >
      {/* Optional logo */}
      <img
        src="/Coredata_Logo_black.svg"
        alt="CoreData"
        style={{
          width: 160,
          marginBottom: 16,
          opacity: 0.9,
        }}
      />

      <CircularProgress
        size={42}
        thickness={4}
        sx={{ color: "#E38500" }}
      />

      <Typography
        sx={{
          mt: 2,
          color: "rgba(255,255,255,0.85)",
          fontSize: 14,
          letterSpacing: "0.3px",
        }}
      >
        Setting up your workspace…
      </Typography>
    </Box>
  );
}
